import { render, staticRenderFns } from "./create-at.vue?vue&type=template&id=1f408aa4&scoped=true"
import script from "./create-at.vue?vue&type=script&lang=js"
export * from "./create-at.vue?vue&type=script&lang=js"
import style0 from "./create-at.vue?vue&type=style&index=0&id=1f408aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f408aa4",
  null
  
)

export default component.exports